import { Routes, Route, Navigate } from "react-router-dom";
import SitesRoutes from "@/pages/sites";
import DocumentsRoutes from "@/pages/documents";
import WorklistRoutes from "@/pages/worklist";
import TranscriptsRoutes from "@/pages/transcripts";
import AuditRoutes from "@/pages/audit";
import AdministrationRoutes from "@/pages/administration";

export default function ClinOpsRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="sites" replace />} />
      <Route path="sites/*" element={<SitesRoutes />} />
      <Route path="documents/*" element={<DocumentsRoutes />} />
      <Route path="worklist/*" element={<WorklistRoutes />} />
      <Route path="transcripts/*" element={<TranscriptsRoutes />} />
      <Route path="audit/*" element={<AuditRoutes />} />
      <Route path="administration/*" element={<AdministrationRoutes />} />
    </Routes>
  );
}
